import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Typography,
  Grid,
  Paper,
  Button,
  IconButton,
} from "@mui/material";
import { AppDataContext } from "../../../common/appContext";
import JWPlayer from "../../../sharedComponents/JWPlayer/JWPlayer";
import PlayerImg from "../../../images/novideo.png";
import { Video_baseUrl } from "../../../services/AzureStorage";
import { PlayerProfileService } from "../../../services/playerProfile.Service";
import shooting from "../../../icons/icons-NBAblue/shooting.png";
import { makeStyles } from "@mui/styles";
import PrimaryVideoImage from "../../../images/C3_B.png";
import SecondaryVideoImage from "../../../images/C3_G.png";
import CustomTooltip from "../../../common/CustomTooltip";
import CustomVideoPlayer from "../../../sharedComponents/CustomVideoPlayer";
import VideoJS from "../../../sharedComponents/videoPlayer/VideoJS";

const useStyles = makeStyles((theme) => ({
  mainContent: {
    // "& .jwplayer": {
    //   width: "450px !important",
    //   height: "220px !important",
    // },
  },
  subtitle: {
    fontWeight: "500",
  },
  paperStyle: {
    margin: "5px",
    padding: "5px",
  },
  btnselected: {
    backgroundColor: "#C8102E", //"#1d428a",
    color: "#fff",
    marginRight: theme.spacing(1),
    "&:hover": {
      backgroundColor: "#C8102E",
    },
  },
  btnunselected: {
    backgroundColor: "#707070",
    color: "#fff",
    marginRight: theme.spacing(1),
    "&:hover": {
      backgroundColor: "#707070",
    },
  },
}));

export default function ProDay({ playerID, setLoading }) {
  const { selectedEventId, user } = useContext(AppDataContext);
  const [eventId, setEventId] = useState(selectedEventId);
  const classes = useStyles();
  const [btn1, setbtn1] = useState(false);
  const [btn2, setbtn2] = useState(false);
  const [btn3, setbtn3] = useState(false);
  const [btn4, setbtn4] = useState(false);
  const [btn5, setbtn5] = useState(false);
  const [playerYear, setplayerYear] = useState([{}]);
  const [proData, setProData] = useState([]);

  useEffect(() => {
    setEventId(selectedEventId);
  }, [selectedEventId]);

  async function loadVideosData() {
    try {
      setLoading(true);
      let response = await PlayerProfileService.getFullcourtAndWorkoutVideos(
        eventId,
        601,
        playerID
      );

      setProData(
        [...response.data].map((v) => ({
          ...v,
          videoAngleFlag: 0,
        }))
      );
    } finally {
      setLoading(false);
    }
  }

  async function loadVideosDatachangedYear(playerEventIdYear) {
    try {
      setLoading(true);
      let response = await PlayerProfileService.getFullcourtAndWorkoutVideos(
        playerEventIdYear,
        601,
        playerID
      );
      setProData(
        [...response.data].map((v) => ({
          ...v,
          videoAngleFlag: 0,
        }))
      );
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadVideosData();
    setbtn1(false);
    setbtn2(false);
    setbtn3(false);
    setbtn4(false);
    setbtn5(false);
    PlayerProfileService.getAnthrosDataByPlayerYear(eventId, playerID).then(
      (response) => {
        setplayerYear(response.data);
        var pdata = response.data;
        pdata.map((item, index) => {
          if (item.eventId === eventId && index == 0) {
            setbtn1(true); //btn1=true;
          } else if (item.eventId === eventId && index == 1) {
            setbtn2(true); // btn2=true;
          } else if (item.eventId === eventId && index == 2) {
            setbtn3(true); // btn2=true;
          } else if (item.eventId === eventId && index == 3) {
            setbtn4(true); //btn4=true;
          } else if (item.eventId === eventId && index == 4) {
            setbtn5(true); // btn5=true;
          }
        });
      }
    );
  }, [eventId]);

  const getyearValue = (playerEventId, index) => {
    if (index === 0) {
      setbtn1(true);
      setbtn2(false);
      setbtn3(false);
      setbtn4(false);
      setbtn5(false);
      //  btn1=true;btn2=false;btn3=false;btn4=false;btn5=false;
    } else if (index === 1) {
      setbtn1(false);
      setbtn2(true);
      setbtn3(false);
      setbtn4(false);
      setbtn5(false); //btn1=false;btn2=true;btn3=false;btn4=false;btn5=false;
    } else if (index === 2) {
      setbtn1(false);
      setbtn2(false);
      setbtn3(true);
      setbtn4(false);
      setbtn5(false); //btn1=false;btn2=false;btn3=true;btn4=false;btn5=false;
    } else if (index === 3) {
      setbtn1(false);
      setbtn2(false);
      setbtn3(false);
      setbtn4(true);
      setbtn5(false); //btn1=false;btn2=false;btn3=false;btn4=true;btn5=false;
    } else if (index === 4) {
      setbtn1(false);
      setbtn2(false);
      setbtn3(false);
      setbtn4(false);
      setbtn5(true); // btn1=false;btn2=false;btn3=false;btn4=false;btn5=true;
    }

    loadVideosDatachangedYear(playerEventId);
  };

  const handleVideoAngleClick = (videoID, videoAngleType) => {
    const newVideoArray = proData.map((video, index) => {
      if (index === videoID) {
        video.videoAngleFlag = videoAngleType;
      }

      return video;
    });

    setProData(newVideoArray);
  };

  function isHttpVideoURL(url) {
    return url.startsWith("http");
  }

  return (
    <>
      <Box display="flex" alignItems={"center"} justifyContent="center" mt={1}>
        {playerYear.length > 1
          ? playerYear.map((item, index) => {
              if (index === 0) {
                return (
                  <>
                    <Typography
                      variant="h6"
                      fontStyle="italic"
                      mr={2}
                      color={"primary"}
                    >
                      Details available for{" "}
                    </Typography>
                    <Button
                      onClick={() => getyearValue(item.eventId, index)}
                      key={index}
                      className={
                        btn1 === true
                          ? classes.btnselected
                          : classes.btnunselected
                      }
                    >
                      Year {item.eventYear}
                    </Button>
                  </>
                );
              } else if (index === 1) {
                return (
                  <Button
                    onClick={() => getyearValue(item.eventId, index)}
                    key={index}
                    className={
                      btn2 === true
                        ? classes.btnselected
                        : classes.btnunselected
                    }
                  >
                    Year {item.eventYear}
                  </Button>
                );
              } else if (index === 2) {
                return (
                  <Button
                    onClick={() => getyearValue(item.eventId, index)}
                    key={index}
                    className={
                      btn3 === true
                        ? classes.btnselected
                        : classes.btndeselected
                    }
                  >
                    Year {item.eventYear}
                  </Button>
                );
              } else if (index === 3) {
                return (
                  <Button
                    onClick={() => getyearValue(item.eventId, index)}
                    key={index}
                    className={
                      btn4 === true
                        ? classes.btnselected
                        : classes.btnunselected
                    }
                  >
                    Year {item.eventYear}
                  </Button>
                );
              } else if (index === 4) {
                return (
                  <Button
                    onClick={() => getyearValue(item.eventId, index)}
                    key={index}
                    className={
                      btn5 === true
                        ? classes.btnselected
                        : classes.btnunselected
                    }
                  >
                    Year {item.eventYear}
                  </Button>
                );
              } else {
                return (
                  <Button
                    onClick={() => getyearValue(item.eventId, index)}
                    key={index}
                    className={
                      btn5 === true
                        ? classes.btnselected
                        : classes.btnunselected
                    }
                  >
                    {item.eventYear}
                  </Button>
                );
              }
            })
          : ""}
      </Box>
      <Box display="flex" justifyContent="center">
        <img
          alt="Contested-Shooting-icon"
          src={shooting}
          height={30}
          width={30}
          style={{
            marginRight: "5px",
            marginTop: "10px",
          }}
        />
        <Typography
          noWrap
          color="primary"
          variant="subtitle1"
          className={classes.subtitle}
          sx={{ marginTop: "10px", fontSize: "25px" }}
        >
          Pro Day
        </Typography>
      </Box>

      {/* core logic Hidden temporary */}
      {/* <Box sx={{ my: 2 }}>
        <Grid
          container
          justifyContent={"center"}
          display="flex"
          spacing={2}
          rowSpacing={3}
        >
          {proData.length > 0 ? (
            proData.map((val, index) => {
              //#Extract thumbnail
              const primaryImageVideo = val.jsonData
                ? JSON.parse(val.jsonData).thumbnail
                : "";
              const secondaryImageVideo = val.secondaryJsonData
                ? JSON.parse(val.secondaryJsonData).thumbnail
                : "";

              return (
                <Grid
                  item
                  lg={6}
                  md={12}
                  sm={12}
                  xs={12}
                  justifyContent="center"
                  display="flex"
                >
                  <Paper
                    sx={{
                      padding: "20px",
                    }}
                    className={classes.mainContent}
                    elevation={2}
                  >
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      sx={{ my: 1 }}
                    >
                      <IconButton
                        size="small"
                        onClick={() => handleVideoAngleClick(index, 0)}
                        sx={{
                          backgroundColor:
                            val.videoAngleFlag === 0
                              ? "rgba(29, 66, 138, 0.2)"
                              : "",
                        }}
                      >
                        <CustomTooltip title="Primary Video" placement="top">
                          <img
                            alt="Primary Video"
                            src={
                              val.videoAngleFlag === 0
                                ? PrimaryVideoImage
                                : SecondaryVideoImage
                            }
                            width="30"
                            height="30"
                          />
                        </CustomTooltip>
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={() => handleVideoAngleClick(index, 1)}
                        sx={{
                          backgroundColor:
                            val.videoAngleFlag === 1
                              ? "rgba(29, 66, 138, 0.2)"
                              : "",
                        }}
                      >
                        <CustomTooltip title="Secondary Video" placement="top">
                          <img
                            alt="Secondary Video"
                            src={
                              val.videoAngleFlag === 1
                                ? PrimaryVideoImage
                                : SecondaryVideoImage
                            }
                            width="30"
                            height="30"
                          />
                        </CustomTooltip>
                      </IconButton>
                    </Box>

                    {val.videoAngleFlag === 0 ? (
                      <Box mt={1}>
                        {val.videoFileName === null ||
                        val.videoFileName === "" ? (
                          <img
                            alt="no-video-found"
                            src={PlayerImg}
                            className="noVideoImage"
                          />
                        ) : (
                          <JWPlayer
                            fileURL={Video_baseUrl(val.videoFileName)}
                            isAutoplay={false}
                            id={"proData" + index}
                            image={Video_baseUrl(primaryImageVideo)}
                            fileName={val.videoFileName}
                          />
                        )}
                      </Box>
                    ) : null}

                    {val.videoAngleFlag === 1 ? (
                      <Box mt={1}>
                        {val.secondaryVideoFileName === null ||
                        val.secondaryVideoFileName === "" ? (
                          <img
                            alt="no-video-found"
                            src={PlayerImg}
                            className="noVideoImage"
                          />
                        ) : (
                          <JWPlayer
                            fileURL={Video_baseUrl(val.secondaryVideoFileName)}
                            isAutoplay={false}
                            id={"proData" + index}
                            image={Video_baseUrl(secondaryImageVideo)}
                            fileName={val.secondaryVideoFileName}
                          />
                        )}
                      </Box>
                    ) : null}
                  </Paper>
                </Grid>
              );
            })
          ) : (
            <Grid item lg={5} md={12} sm={12} xs={12}>
              <Paper
                mt={2}
                sx={{
                  padding: "2rem",
                  border: "2px solid lightgrey",
                  borderRadius: "5px",
                }}
                className={classes.mainContent}
                elevation={2}
              >
                <Typography
                  noWrap
                  color="primary"
                  variant="subtitle2"
                  textAlign="center"
                >
                  Video
                </Typography>
                <Box
                  mt={1}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <img
                    alt="no-video-found"
                    src={PlayerImg}
                    className="noVideoImage"
                  />
                </Box>
              </Paper>
            </Grid>
          )}
        </Grid>
      </Box> */}

      <Box sx={{ my: 2 }}>
        <Grid
          container
          justifyContent={"center"}
          display="flex"
          spacing={2}
          rowSpacing={3}
        >
          {" "}
          {proData.length > 0 ? (
            proData.map((val, index) => {
              //#Extract thumbnail
              const primaryImageVideo = val.jsonData
                ? JSON.parse(val.jsonData).thumbnail
                : "";
              const secondaryImageVideo = val.secondaryJsonData
                ? JSON.parse(val.secondaryJsonData).thumbnail
                : "";

              const isHardCodeHttpBlob = val.videoFileName
                ? isHttpVideoURL(val.videoFileName)
                : false;

              if (isHardCodeHttpBlob) {
                return (
                  <Grid item lg={10} md={10} sm={12} xs={12}>
                    <Box className={classes.fullWidthPaper} elevation={2}>
                      {/* Primary Video Section */}
                      {val.videoAngleFlag === 0 ? (
                        <>
                          {val.videoFileName === null ||
                          val.videoFileName === "" ? (
                            <Box
                              mt={1}
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              {" "}
                              <img
                                alt="no-video-found"
                                src={PlayerImg}
                                className="noVideoImage"
                              />
                            </Box>
                          ) : (
                            <CustomVideoPlayer url={val.videoFileName} />
                          )}
                        </>
                      ) : null}

                      {/* Secondary Video section */}
                      {val.videoAngleFlag === 1 ? (
                        <>
                          {val.secondaryVideoFileName === null ||
                          val.secondaryVideoFileName === "" ? (
                            <Box
                              mt={1}
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <img
                                alt="no-video-found"
                                src={PlayerImg}
                                className="noVideoImage"
                              />
                            </Box>
                          ) : (
                            <CustomVideoPlayer
                              url={val.secondaryVideoFileName}
                            />
                          )}
                        </>
                      ) : null}
                    </Box>
                  </Grid>
                );
              } else {
                return (
                  <Grid
                    item
                    lg={6}
                    md={12}
                    sm={12}
                    xs={12}
                    justifyContent="center"
                    display="flex"
                  >
                    <Paper
                      sx={{
                        padding: "20px",
                      }}
                      className={classes.mainContent}
                      elevation={2}
                    >
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        sx={{ my: 1 }}
                      >
                        <IconButton
                          size="small"
                          onClick={() => handleVideoAngleClick(index, 0)}
                          sx={{
                            backgroundColor:
                              val.videoAngleFlag === 0
                                ? "rgba(29, 66, 138, 0.2)"
                                : "",
                          }}
                        >
                          <CustomTooltip title="Primary Video" placement="top">
                            <img
                              alt="Primary Video"
                              src={
                                val.videoAngleFlag === 0
                                  ? PrimaryVideoImage
                                  : SecondaryVideoImage
                              }
                              width="30"
                              height="30"
                            />
                          </CustomTooltip>
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={() => handleVideoAngleClick(index, 1)}
                          sx={{
                            backgroundColor:
                              val.videoAngleFlag === 1
                                ? "rgba(29, 66, 138, 0.2)"
                                : "",
                          }}
                        >
                          <CustomTooltip
                            title="Secondary Video"
                            placement="top"
                          >
                            <img
                              alt="Secondary Video"
                              src={
                                val.videoAngleFlag === 1
                                  ? PrimaryVideoImage
                                  : SecondaryVideoImage
                              }
                              width="30"
                              height="30"
                            />
                          </CustomTooltip>
                        </IconButton>
                      </Box>

                      {val.videoAngleFlag === 0 ? (
                        <Box mt={1}>
                          {val.videoFileName === null ||
                          val.videoFileName === "" ? (
                            <img
                              alt="no-video-found"
                              src={PlayerImg}
                              className="noVideoImage"
                            />
                          ) : (
                            <VideoJS
                              fileURL={Video_baseUrl(val.videoFileName)}
                              isAutoplay={false}
                              id={"proData" + index}
                              image={Video_baseUrl(primaryImageVideo)}
                              fileName={val.videoFileName}
                              isSlowMo={true}
                              isDownload={true}
                            />
                          )}
                        </Box>
                      ) : null}

                      {val.videoAngleFlag === 1 ? (
                        <Box mt={1}>
                          {val.secondaryVideoFileName === null ||
                          val.secondaryVideoFileName === "" ? (
                            <img
                              alt="no-video-found"
                              src={PlayerImg}
                              className="noVideoImage"
                            />
                          ) : (
                            <VideoJS
                              fileURL={Video_baseUrl(
                                val.secondaryVideoFileName
                              )}
                              isAutoplay={false}
                              id={"proData" + index}
                              image={Video_baseUrl(secondaryImageVideo)}
                              fileName={val.secondaryVideoFileName}
                              isSlowMo={true}
                              isDownload={true}
                            />
                          )}
                        </Box>
                      ) : null}
                    </Paper>
                  </Grid>
                );
              }
            })
          ) : (
            <Grid item lg={5} md={12} sm={12} xs={12}>
              <Paper
                mt={2}
                sx={{
                  padding: "2rem",
                  border: "2px solid lightgrey",
                  borderRadius: "5px",
                }}
                className={classes.mainContent}
                elevation={2}
              >
                <Typography
                  noWrap
                  color="primary"
                  variant="subtitle2"
                  textAlign="center"
                >
                  Video
                </Typography>
                <Box
                  mt={1}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <img
                    alt="no-video-found"
                    src={PlayerImg}
                    className="noVideoImage"
                  />
                </Box>
              </Paper>
            </Grid>
          )}
        </Grid>
      </Box>
    </>
  );
}
